import React from "react";
import classes from "./Section1.module.css";
import { FaCheckCircle } from "react-icons/fa";

// Image
import aboutImg from "../../img/about-section-01.webp";

export default function Section1() {
  const points = [
    "High-performance IT hardware distribution across the USA.",
    "Custom solutions for servers, PCs, and networking equipment.",
    "Maximizing IT budgets while providing reliable, cost-effective hardware.",
    "Comprehensive support for business and home IT infrastructure.",
  ];

  return (
    <section className={classes.section1Wrapper}>
      <div className={classes.section1Grid}>
        {/* Left Column - Image */}
        <div className={classes.imageWrapper}>
          <img src={aboutImg} alt="Prime Cloud Systems Company History" />
        </div>

        {/* Right Column - Content */}
        <div className={classes.contentWrapper}>
          <h2 className={classes.title}>Company History & Key Moments</h2>
          <p className={classes.description}>
            At <b>Prime Cloud Systems</b>, we are committed to delivering
            high-quality IT hardware solutions to individuals, IT professionals,
            and businesses across the USA. Our expertise spans laptops, desktop
            PCs, servers, memory modules, storage devices, printers, and
            networking equipment.
          </p>
          <p className={classes.description}>
            Our mission is to provide reliable, cost-effective, and cutting-edge
            technology solutions that empower our customers to optimize
            performance, extend the life of their equipment, and build scalable
            IT infrastructure with confidence.
          </p>

          <ul className={classes.pointsList}>
            {points.map((point, index) => (
              <li key={index}>
                <FaCheckCircle className={classes.icon} />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
